import React, {Component, PropTypes} from 'react'
import {List} from 'immutable'
import InputControl from 'components/InputControl';
import './InfoBlockStuff.scss'


class InfoBlockStuff extends Component {

    static propTypes = {
        stuff: PropTypes.instanceOf(List),
        totalWeight: PropTypes.number,
        totalVolume: PropTypes.number,
    }

    static defaultProps = {
        totalWeight: 0,
        totalVolume: 0,
    }

    render() {
        return (
            <div className="InfoBlockStuff">
                <div className="InfoBlockStuff-items">
                    {this.props.stuff.map((item, index) => (
                        <div key={`stuff-item-${index}`} className="InfoBlockStuff-stuffItem">
                            <span>{item.get('name') ? item.get('name') : item.getIn(['attributes', 'name', 'value'])}</span>
                            <span>{item.getIn(['attributes', 'quantity', 'value'])}</span>
                        </div>
                    ))}
                </div>

                <div className="InfoBlockStuff-total">
                    <label className="CargosInfo-parameter">
                        <span>Общий объём</span>
                        <div>
                            <InputControl className="CargosInfo-inputControl"
                                          value={Math.round(this.props.totalVolume * 100) / 100}
                                          readOnly={true} />
                            <span className="CargosInfo-measure">м<sup>3</sup></span>
                        </div>
                    </label>
                    <label className="CargosInfo-parameter">
                        <span>Общий вес</span>
                        <div>
                            <InputControl className="CargosInfo-inputControl"
                                          value={Math.round(this.props.totalWeight * 100) / 100}
                                          readOnly={true} />
                            <span className="CargosInfo-measure">кг</span>
                        </div>
                    </label>

                </div>
            </div>
        )
    }
}


export default InfoBlockStuff;



// WEBPACK FOOTER //
// ./client/components/InfoBlockStuff/InfoBlockStuff.js